import { useI18n } from '@i18n/useI18n';
import { ReactNode } from 'react';
import { ActiveContainer, BgOverlay } from './ActivePresence.styled';
import BG_Icon from "@assets/svg/attender_a.svg";
import moment from 'moment';
import { useStore } from '@store/appStore';

interface IProps {
  time: string,
}


export const ActivePresence = (props: IProps) => {
  const { QRScreen, setQRScreen } = useStore();
  const i18n = useI18n();
  let utcOffset = moment().utcOffset();
  let time = moment(props.time).add(utcOffset, 'minutes').format("HH:mm");

  return (
    <ActiveContainer onClick={() => setQRScreen(true)}>
      <span>{i18n.t("profile-checkedin")} {time}</span>
      <BgOverlay><BG_Icon /></BgOverlay>
    </ActiveContainer>
  );
};

export default ActivePresence;
